"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const ValueObject_1 = require("../Common/ValueObject");
var Status;
(function (Status) {
    Status["None"] = "None";
    Status["PrepareReceive"] = "PrepareReceive";
    Status["Receiving"] = "Receiving";
    Status["Received"] = "Received";
    Status["RecevingFailed"] = "RecevingFailed";
    Status["NotExist"] = "NotExist";
    Status["PrepareSend"] = "PrepareSend";
    Status["Sending"] = "Sending";
    Status["SendingFailed"] = "SendingFailed";
    Status["Sent"] = "Sent";
})(Status = exports.Status || (exports.Status = {}));
class ChatMessageAttachmentStatus extends ValueObject_1.ValueObject {
    //public constructor(cmas: { Name: string, ReceivingStatus: Status });
    //public constructor(cmas: { Name: string, CreatedTime: Date, ReceivingStatus: Status });
    // public constructor(cmas: {
    //   Name: string, CreatedTime: Date,
    //   ReceivingStatus: Status, ReceivedCurBytes: number, ReceivedTotalBytes: number,
    //   SendingStatus: Status, SendingCurBytes: number, SendingTotalBytes: number
    // });
    //public constructor(cmas?: Partial<ChatMessageAttachmentStatus>);
    constructor(cmas) {
        super();
        this.Name = "";
        this.IsInStorage = false;
        this.Status = Status.None;
        //public Status ReceivingStatus { get; private set; } = Status.None;
        this.CurBytes = 0;
        //public long ReceivedCurBytes { get; private set; }
        this.TotalBytes = 0;
        //public long ReceivedTotalBytes { get; private set; }
        //public readonly SendingStatus: Status = Status.None;
        //public Status SendingStatus { get; private set; } = Status.None;
        //public readonly SendingCurBytes: number = 0;
        //public long SendingCurBytes { get; private set; }
        //public readonly SendingTotalBytes: number = 0;
        //public long SendingTotalBytes { get; private set; }
        this.CreatedTime = new Date();
        //public DateTime CreatedTime { get; private set; }
        this.LastUpdatedTime = new Date();
        if (cmas) {
            this.Name = cmas.Name || this.Name;
            this.IsInStorage = cmas.IsInStorage || this.IsInStorage;
            this.Status = cmas.Status || this.Status;
            this.CurBytes = cmas.CurBytes || this.CurBytes;
            this.TotalBytes = cmas.TotalBytes || this.TotalBytes;
            //this.SendingStatus = cmas.SendingStatus || this.SendingStatus;
            //this.SendingCurBytes = cmas.SendingCurBytes || this.SendingCurBytes;
            //this.SendingTotalBytes = cmas.SendingTotalBytes || this.SendingTotalBytes;
            this.CreatedTime = cmas.CreatedTime || this.CreatedTime;
            this.LastUpdatedTime = new Date();
        }
    }
    //public DateTime LastUpdatedTime { get; private set; }
    get IsReceiving() { return this.Status === Status.PrepareReceive || this.Status === Status.Receiving; }
    get IsSending() { return this.Status === Status.PrepareSend || this.Status === Status.Sending; }
    DoesExist() { return this.IsInStorage; }
    *GetEqualityComponents() {
        yield* [this.Name,
            this.IsInStorage,
            this.Status, this.CurBytes, this.TotalBytes,
            //this.SendingStatus, this.SendingCurBytes, this.SendingTotalBytes,
            this.CreatedTime, this.LastUpdatedTime
        ];
    }
    toString() { return JSON.stringify(this); }
    ApplyIsInStorage(isInStorage) {
        return new ChatMessageAttachmentStatus({
            Name: this.Name,
            IsInStorage: isInStorage,
            Status: this.Status,
            CurBytes: this.CurBytes,
            TotalBytes: this.TotalBytes,
        });
    }
    ApplyReceivingStatus(receivingStatus) {
        return new ChatMessageAttachmentStatus({
            Name: this.Name,
            IsInStorage: this.IsInStorage,
            Status: receivingStatus,
            CurBytes: this.CurBytes,
            TotalBytes: this.TotalBytes,
            //SendingStatus: this.SendingStatus,
            //SendingCurBytes: this.SendingCurBytes,
            //SendingTotalBytes: this.SendingTotalBytes,
            CreatedTime: this.CreatedTime,
        });
    }
    ApplyReceivingStats(receivingCur, receivingTotal) {
        return new ChatMessageAttachmentStatus({
            Name: this.Name,
            IsInStorage: this.IsInStorage,
            Status: this.Status,
            CurBytes: receivingCur,
            TotalBytes: receivingTotal,
            //SendingStatus: this.SendingStatus,
            //SendingCurBytes: this.SendingCurBytes,
            //SendingTotalBytes: this.SendingTotalBytes,
            CreatedTime: this.CreatedTime,
        });
    }
    ApplySendingStatus(sendingStatus) {
        return new ChatMessageAttachmentStatus({
            Name: this.Name,
            IsInStorage: this.IsInStorage,
            Status: sendingStatus,
            CurBytes: this.CurBytes,
            TotalBytes: this.TotalBytes,
            //SendingStatus: sendingStatus,
            //SendingCurBytes: this.SendingCurBytes,
            //SendingTotalBytes: this.SendingTotalBytes,
            CreatedTime: this.CreatedTime,
        });
    }
    ApplySendingStatusStats(sendingStatus, sendingCur, sendingTotal) {
        return new ChatMessageAttachmentStatus({
            Name: this.Name,
            IsInStorage: this.IsInStorage,
            Status: sendingStatus,
            CurBytes: sendingCur,
            TotalBytes: sendingTotal,
            //SendingStatus: sendingStatus,
            //SendingCurBytes: sendingCur,
            //SendingTotalBytes: sendingTotal,
            CreatedTime: this.CreatedTime,
        });
    }
}
ChatMessageAttachmentStatus.INVALID = new ChatMessageAttachmentStatus();
exports.ChatMessageAttachmentStatus = ChatMessageAttachmentStatus;
//# sourceMappingURL=ChatMessageAttachmentStatus.js.map